<template>
  <div>
    <img src="@/assets/images/policy/policies.png" alt="" class="fill-img" />
    <div class="declare_fill">
      <h3>项目内容</h3>
      <ul class="content-details">
        <li>
          <span>项目名称</span><span> {{ projectContent.title }}</span>
        </li>
        <li>
          <span>项目类型</span><span> {{ projectContent.type }}</span>
        </li>
        <li>
          <span>金额</span><span> {{ projectContent.money }}元</span>
        </li>
      </ul>
      <h3>企业信息</h3>
      <ul class="content-details">
        <li>
          <span>企业名称</span><span> {{ basicInfo.companyName }}</span>
        </li>
        <li>
          <span>统一社会信用代码</span><span> {{ basicInfo.licenseNum }}</span>
        </li>
        <li>
          <span>注册地址</span><span> {{ basicInfo.companyAddress }}</span>
        </li>
        <li>
          <span>企业法人</span><span>{{ basicInfo.legalName }}</span>
        </li>
        <li>
          <span>联系人</span
          ><span>
            <el-input
              placeholder="请输入联系人"
              v-model="ruleForm.contacts"
            ></el-input
          ></span>
        </li>
        <li>
          <span>联系人电话</span
          ><span>
            <el-input
              placeholder="请输入联系人电话"
              v-model="ruleForm.contactsPhone"
            ></el-input
          ></span>
        </li>
      </ul>
      <div class="warning_message">
        <h4>温馨提示：</h4>
        <p>
          1、请按照附件要求，每条记录以一个文件形式上传，如果多个文件则先合并为一个文件（建议DOC或PDF或ZIP格式）后上传。
        </p>
        <p>
          2、视频文件不超过2GB，其他类型文件不超过50M，格式为JPG、PNG、DOC、DOCX、WPS、PDF、XLS、XLSX、ZIP格式的文件。
        </p>
        <p>3、对于大于一页的单个附件，如审计报告等，建议采用PDF格式。</p>
        <p>
          4、附件材料的复印件或者原件，以扫描或者拍照的形式，确保足够清晰、否则将影响单位信息的审核，直至专项资金的审批拨付。
        </p>
        <div class="filelist">
          <label>附件</label>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="headers"
            :before-remove="beforeRemove"
            multiple
            :limit="3"
            :on-exceed="handleExceed"
            :on-success="handleSuccess"
            :on-error="handleError"
          >
            <el-button type="button" class="el-icon-upload2"
              >上传附件</el-button
            >
          </el-upload>
        </div>
      </div>
      <div class="btn-list">
        <el-button type="primary" @click="submitApply">提交申请</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getStorage } from "@/common/utils";
import { getCompany, declareItemApply } from "@/api/account";
import cookie from "js-cookie";
import config from "@/config";
export default {
  name: "Declare",
  data() {
    return {
      uploadUrl: `${config.commonUrl}common/upload/fileTemplate`,
      headers: { accessToken: getStorage("token") },
      projectContent: {},
      basicInfo: {},
      fileList: [],
      ruleForm: {
        contacts: "",
        contactsPhone: "",
        fileList: [],
      },
    };
  },
  mounted() {
    let { title, type, money } = this.$route.query;
    this.projectContent = {
      title,
      type,
      money,
    };

    this.basicInfo = JSON.parse(localStorage.getItem("basic"));
    console.log(this.basicInfo);
    getCompany().then((res) => {
      if (res.data.code == 200) {
        this.basicInfo = res.data.result;
      }
    });
  },
  methods: {
    submitApply() {
      if (cookie.get("accessToken")) {
        let formdata = new FormData();
        for (let key in this.ruleForm) {
          if (key != "fileList") {
            if (!this.ruleForm[key]) {
              this.$message.warning("请填写企业信息");
              return;
            } else {
              formdata.append(key, this.ruleForm[key]);
            }
          } else {
            if (this.fileList.length) {
              formdata.append("fileIds", this.fileList.join(","));
            } else {
              this.$message.warning("请上传附件");
              return;
            }
          }
        }
        formdata.append("companyName", this.basicInfo.companyName);
        formdata.append("companyCreditCode", this.basicInfo.licenseNum);
        formdata.append(
          "declareItemDirectionId",
          this.$route.query.directionId
        );
        declareItemApply(formdata).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("申报成功");
            setTimeout(() => {
              this.$router.push({
                path: "/pcm/apply",
              });
            }, 1000);
          }
        });
      } else {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
        .then(() => {
          let arr = fileList.filter((obj) => obj.uid != file.uid);
          this.fileList = [];
          arr.forEach((item) => {
            this.fileList.push(item.response.result.id);
          });
          console.log(arr, this.fileList);
          return true;
        })
        .catch(() => {});
    },
    onChange(file, fileList) {
      file.status = "success";
      this.fileList = fileList;
      console.log(this.fileList, fileList, "filelist");
    },
    handleSuccess(res) {
      if (res.code == 200) {
        this.fileList.push(res.result.id);
        this.ruleForm.fileList.push(res.result);
      } else {
        this.$message.warning(res.message);
      }
    },
    handleError(err) {
      this.$message.warning(JSON.parse(err.message).message);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.fill-img {
  margin-top: 10px;
}
.declare_fill {
  width: 1400px;
  margin: 20px auto;
  .filelist {
    margin-top: 40px;
    margin-left: 20px;
    display: flex;
    align-items: center;
    label {
      margin-right: 20px;
    }
  }
  h3 {
    text-align: center;
    margin: 60px auto 40px;
  }
  .content-details {
    margin: 0 auto;
    li {
      list-style: none;
      font-size: 16px;
      color: #999;
      margin: 25px 0;
      span {
        &:first-child {
          color: #333;
          margin-right: 40px;
          width: 150px;
          display: inline-block;
        }
      }
      ::v-deep {
        .el-input {
          width: 300px;
        }
      }
    }
  }
  .warning_message {
    p {
      padding-left: 15px;
      color: #666666;
      font-size: 14px;
      span {
        color: rgb(249, 84, 17);
      }
    }
  }
  .file_first_page {
    width: 80%;
    margin: 40px auto;
    .page_subtitle {
      border-bottom: 1px solid #666666;
      text-align: right;
      padding-bottom: 10px;
      padding-right: 5%;
    }
    .project_message {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 200px;
      padding: 0 5%;
      p {
        &:first-child {
          .add_line {
            display: inline-block;
            margin: 3px 5px;
            text-decoration: underline;
          }
        }
      }
    }
    h3 {
      text-align: center;
      font-size: 28px;
      margin: 80px 0 200px;
    }
    .base_message {
      width: 100%;
      margin-bottom: 150px;
      p {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        span {
          display: flex;
          justify-content: center;
          &:first-child {
            flex: 2;
            justify-content: flex-end;
          }
          &.add_line {
            flex: 3;
            justify-content: flex-start;
            margin-bottom: 3px;
            position: relative;
            &::after {
              position: absolute;
              width: 60%;
              height: 1px;
              left: 0;
              bottom: -4px;
              background-color: #666666;
              content: "";
            }
          }
        }
      }
    }
  }
  .btn-list {
    width: 100%;
    display: flex;
    justify-content: center;
    .el-button {
      a {
        text-decoration: none;
        color: #ffffff;
      }
    }
  }
}
@media only screen and (max-width: 1440px) {
  .declare_fill {
    width: 1200px;
  }
}
</style>